import { render, staticRenderFns } from "./ServiceListForm.vue?vue&type=template&id=3655e6d2&"
import script from "./ServiceListForm.vue?vue&type=script&lang=js&"
export * from "./ServiceListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports